import React, { useEffect, useState } from 'react'
import YouTube from 'react-youtube'
import { MdClose } from 'react-icons/md'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import DlpIcon from './DlpIcon'
import { LEVELS } from './DlpData'
import { formatDuration } from './dlpUtils'

const DlpCardModal = ({ card, section, onClose }) => {

    const [duration, setDuration] = useState(null)

    useEffect(() => {
        setDuration(null)
    }, [card?.videoId])

    useEffect(() => {
        const onKeyDown = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKeyDown)
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKeyDown)
            document.body.style.overflow = ''
        }
    }, [onClose])

    if (!card) return null

    return (
        <div className="dlp-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
            <div className="dlp-modal" role="dialog" aria-modal="true">
                <div className="dlp-modal-header">
                    <div className="dlp-modal-icon">
                        <DlpIcon name={card.icon} />
                    </div>
                    <div style={{ minWidth: 0 }}>
                        <h5>{card.t}</h5>
                        <div className="dlp-modal-meta">
                            {section?.lv && <span className={`dlp-pill dlp-lv${section.lv}`}>{LEVELS[section.lv].full}</span>}
                            {duration && <span className="dlp-mins">{duration}</span>}
                            <span className="dlp-mins">{(section?.lv || duration) ? '· ' : ''}{section?.title}</span>
                        </div>
                    </div>
                    <button className="dlp-modal-close" onClick={onClose} aria-label="Close">
                        <MdClose size={18} />
                    </button>
                </div>
                <div className="dlp-modal-body">
                    {card.videoId ? (
                        <div className="dlp-player">
                            <YouTube
                                videoId={card.videoId}
                                opts={{ width: '100%', height: '100%', playerVars: { autoplay: 1, rel: 0 } }}
                                className="dlp-yt-wrap"
                                iframeClassName="dlp-yt-iframe"
                                title={card.t}
                                onReady={(e) => setDuration(formatDuration(e.target.getDuration()))}
                            />
                        </div>
                    ) : (
                        <div className="dlp-player dlp-norec">
                            <div className="dlp-norec-in">
                                Not recorded yet<br />
                                <span style={{ fontSize: '12px' }}>This module is planned — check back soon.</span>
                            </div>
                        </div>
                    )}

                    {card.learn?.length > 0 &&
                        <>
                            <div className="dlp-lbl">What you will learn</div>
                            <ul className="dlp-learn">
                                {card.learn.map((item, i) => (
                                    <li key={i}>
                                        <span className="dlp-check"><IoCheckmarkCircleOutline size={17} /></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    }

                    {card.path?.length > 0 &&
                        <>
                            <div className="dlp-lbl">Where in the console</div>
                            {(Array.isArray(card.path[0]) ? card.path : [card.path]).map((group, gi) => (
                                <div className="dlp-path" key={gi}>
                                    {group.map((p, i) => (
                                        <React.Fragment key={i}>
                                            {i > 0 && <i>&rsaquo;</i>}
                                            <b>{p}</b>
                                        </React.Fragment>
                                    ))}
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default DlpCardModal
